import { FormFields, FormValidationSchema } from '@/common/interfaces';

export enum PagesCriticalCssSettingsInputs {
  StyleFiles = 'styleFiles',
  ScreenDimensions = 'screenDimensions',
}

export enum PagesCriticalCssInputs {
  Css = 'css',
}

export type PagesCriticalCssSettingsFormFields = FormFields<typeof PagesCriticalCssSettingsInputs>;

export type PagesCriticalCssSettingsFormValidationSchema = FormValidationSchema<PagesCriticalCssSettingsFormFields>;

export type PagesCriticalCssFormFields = FormFields<typeof PagesCriticalCssInputs>;

export type PagesCriticalCssFormValidationSchema = FormValidationSchema<PagesCriticalCssFormFields>;

export enum PagesCriticalCssGenerationStatus {
  NotGenerated = 'notGenerated',
  Queued = 'queued',
  Generating = 'generating',
  Generated = 'generated',
  GenerationFailed = 'generationFailed',
}

export interface PagesCriticalCssScreenDimension {
  width: number;
  height: number;
}

export type PagesCriticalCssStyleFile = {
  id: string;
  name: string;
};

export type PagesCriticalCssGenerationSummary = {
  totalPages: number;
  statuses: Record<PagesCriticalCssGenerationStatus, number>;
};

export enum PagesCriticalCssGatewayKeys {
  GenerationStatusChanged = 'pagesCriticalCssGenerationStatusChanged',
}

export interface PagesCriticalCssGenerationStatusChangedPayload {
  siteId: string;
  pages: Array<{ pageId: string; generationStatus: PagesCriticalCssGenerationStatus }>;
}

export const MAX_SCREEN_DIMENSIONS = 6;
